import api from '../lib/api';

export interface DecagonConfig {
  apiKey: string;
  workspaceId: string;
}

export interface DecagonIntegrationStatus {
  connected: boolean;
  lastSyncAt?: string;
  config?: {
    workspaceId: string;
  };
}

export interface DecagonConversationMetrics {
  date: string;
  conversationCount: number;
  avgHandleTime: number;
  channel: string;
  aiAssisted: boolean;
}

const decagonService = {
  async connect(organizationId: string, config: DecagonConfig): Promise<{ success: boolean; message: string }> {
    const response = await api.post('/integrations/decagon/connect', {
      organizationId,
      config,
    });
    return response.data;
  },

  async testConnection(organizationId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.get(`/integrations/decagon/${organizationId}/test`);
    return response.data;
  },

  async syncAgents(organizationId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`/integrations/decagon/${organizationId}/sync-agents`);
    return response.data;
  },

  async fetchMetrics(
    organizationId: string,
    startDate: string,
    endDate: string
  ): Promise<{ success: boolean; message: string; data: DecagonConversationMetrics[] }> {
    const response = await api.post(`/integrations/decagon/${organizationId}/fetch-metrics`, {
      startDate,
      endDate,
    });
    return response.data;
  },

  async getStatus(organizationId: string): Promise<DecagonIntegrationStatus> {
    const response = await api.get(`/integrations/decagon/${organizationId}/status`);
    return response.data;
  },

  async disconnect(organizationId: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`/integrations/decagon/${organizationId}/disconnect`);
    return response.data;
  },
};

export default decagonService;
